import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

interface SectionHeadingProps {
  icon: LucideIcon;
  children: ReactNode;
}

/** H2 mit vorangestelltem, kleinem Icon für die Abschnitte der Ergebnisseite. */
export function SectionHeading({ icon: Icon, children }: SectionHeadingProps) {
  return (
    <h2 className="section-heading">
      <Icon className="section-heading__icon" aria-hidden="true" />
      {children}
    </h2>
  );
}
